import { Navigate } from "react-router";
import { useProjectContext } from "@/app/project-context";

/**
 * `/projects/:projectId/setup` — go to whichever step this project reached.
 *
 * It no longer needs a loading state of its own: `ProjectLayout` has already
 * resolved the project by the time this renders, so the cursor is simply there.
 * Previously this had to wait on its own query and was careful not to guess
 * step 1, because guessing would bounce a returning user to the start and then
 * forward again, losing whatever they had typed on the way.
 */
export function SetupEntry() {
  const { project, projectId } = useProjectContext();
  return <Navigate to={`/projects/${projectId}/setup/${project.setupStep}`} replace />;
}
